module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1121.d7749c0d.png";